(()=>{
const reduce=matchMedia('(prefers-reduced-motion: reduce)');
let reviewImageObserver;
function init(scope=document){
const reviewImage = document.querySelector('[data-sm-review-image]')?.dataset.smReviewImage;
if (reviewImage && !reviewImageObserver) {
  const updateReviewImage = () => document.querySelectorAll('.jdgm-write-review-modal__product-image img').forEach(image => {
    if (image.getAttribute('src') !== reviewImage) {
      image.removeAttribute('srcset');
      image.src = reviewImage;
    }
  });
  reviewImageObserver = new MutationObserver(updateReviewImage);
  reviewImageObserver.observe(document.body, {childList: true, subtree: true});
  updateReviewImage();
}
scope.querySelectorAll('[data-sm-media]').forEach(root => {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';
  const track = root.querySelector('[data-sm-track]');
  const slides = [...root.querySelectorAll('[data-sm-slide]')];
  const thumbs = [...root.querySelectorAll('[data-sm-media-thumb]')];
  const range = root.querySelector('[data-sm-gallery-range]');
  let index = 0, frame = 0;
  const show = (requested, dragging = false) => {
    index = Math.max(0, Math.min(slides.length - 1, requested));
    track.scrollTo({left: slides[index].offsetLeft - slides[0].offsetLeft,
      behavior: reduce.matches || dragging ? 'instant' : 'smooth'});
  };
  const update = () => {
    index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
    root.querySelector('[data-sm-counter]').textContent = `${index + 1} / ${slides.length}`;
    root.querySelector('[data-sm-prev]').disabled = index === 0;
    root.querySelector('[data-sm-next]').disabled = index === slides.length - 1;
    if (range) {
      range.value = String(index);
      range.setAttribute('aria-valuetext', slides[index].dataset.smImageLabel);
      range.style.setProperty('--position', `${index / (slides.length - 1) * 100}%`);
    }
  };
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
  root.querySelector('[data-sm-prev]').addEventListener('click', () => show(index - 1));
  root.querySelector('[data-sm-next]').addEventListener('click', () => show(index + 1));
  range?.addEventListener('input', () => show(Number(range.value), true));
  track.addEventListener('scroll', () => {cancelAnimationFrame(frame); frame = requestAnimationFrame(update);}, {passive: true});
  track.addEventListener('keydown', event => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  let drag;
  track.addEventListener('dragstart', event => {
    if (matchMedia('(min-width: 750px)').matches) event.preventDefault();
  });
  track.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse' || event.button !== 0 || !matchMedia('(min-width: 750px)').matches) return;
    drag = {x: event.clientX, left: track.scrollLeft, index, pointerId: event.pointerId, moved: false};
    track.setPointerCapture(event.pointerId);
  });
  track.addEventListener('pointermove', event => {
    if (!drag || event.pointerId !== drag.pointerId) return;
    const distance = event.clientX - drag.x;
    if (Math.abs(distance) > 6) drag.moved = true;
    if (!drag.moved) return;
    event.preventDefault();
    track.classList.add('is-dragging');
    track.scrollLeft = drag.left - distance;
  });
  const finishDrag = event => {
    if (!drag || event.pointerId !== drag.pointerId) return;
    const distance = event.clientX - drag.x;
    let requested = Math.round(track.scrollLeft / track.clientWidth);
    if (event.type !== 'pointercancel' && drag.moved && Math.abs(distance) > 48 && requested === drag.index) {
      requested = drag.index + (distance < 0 ? 1 : -1);
    }
    const moved = drag.moved;
    drag = null;
    track.classList.remove('is-dragging');
    if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
    if (moved) show(requested);
  };
  track.addEventListener('pointerup', finishDrag);
  track.addEventListener('pointercancel', finishDrag);
  update();
});
scope.querySelectorAll('[data-sm-compare]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const range=root.querySelector('[data-sm-range]');const benefits=root.parentElement.querySelectorAll('[data-sm-benefit]');const update=()=>{root.style.setProperty('--reveal',range.value+'%');root.dataset.revealEdge=Number(range.value)<5?'before':Number(range.value)>95?'after':'both';range.setAttribute('aria-valuetext',range.value+'%');benefits.forEach((el,i)=>el.classList.toggle('is-muted',Number(range.value)<20+i*20))};range.addEventListener('input',update);update()});
scope.querySelectorAll('[data-sm-product]').forEach(root => {
  const sticky = root.querySelector('[data-sm-sticky]');
  const form = root.querySelector('.sm-buy-form');
  const submit = root.querySelector('[data-sm-add]');
  const heading = root.querySelector('h1');
  if (!sticky || !form || !submit || sticky.dataset.ready) return;
  sticky.dataset.ready = '1';
  let frame = 0;
  const update = () => {
    sticky.querySelector('[data-sm-sticky-size]').textContent = root.querySelector('[data-sm-size]:checked')?.value || '';
    sticky.querySelector('[data-sm-sticky-price]').textContent = submit.querySelector('[data-sm-total]')?.textContent || '';
    sticky.querySelector('button').disabled = submit.disabled;
    const buy = submit.getBoundingClientRect();
    const title = heading.getBoundingClientRect();
    const product = root.getBoundingClientRect();
    const primaryVisible = buy.top < innerHeight - 12 && buy.bottom > 100;
    sticky.hidden = primaryVisible || title.top > innerHeight - 80 || product.bottom < 140;
  };
  const schedule = () => {cancelAnimationFrame(frame); frame = requestAnimationFrame(update);};
  const changed = () => queueMicrotask(update);
  form.addEventListener('change', changed);
  document.addEventListener('snugmag:offer-change', changed);
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule);
  sticky.querySelector('button').addEventListener('click', () => form.requestSubmit(submit));
  const unloaded = event => {
    if (event.target.contains(root)) {
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      document.removeEventListener('snugmag:offer-change', changed);
      document.removeEventListener('shopify:section:unload', unloaded);
      cancelAnimationFrame(frame);
    }
  };
  document.addEventListener('shopify:section:unload', unloaded);
  update();
});
if(!reduce.matches){const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('sm-reveal');observer.unobserve(e.target)}}),{threshold:.12});scope.querySelectorAll('.sm-feature-photo,.sm-compare-grid,.sm-animation,.sm-journal-card,.sm-guide-step').forEach(el=>observer.observe(el))}
}
document.addEventListener('DOMContentLoaded',()=>init());document.addEventListener('shopify:section:load',e=>init(e.target));
})();
